import moment from "moment";
import React from "react";
import DataTable from "src/components/Table";
import { StyledTableCell } from "src/components/Table/TableCell";
import TableRow from "src/components/Table/TableRow";
import { colors } from "src/styles";
import { LocationSpecificWashroomLogsForTable, ID } from "src/types";
import styled from "styled-components";

export interface CleaningLogsTableProps {
  isLoading: boolean;
  headers: string[];
  data: LocationSpecificWashroomLogsForTable[];
  onRowClick: (id: ID) => void;
  isManager?: boolean;
  isMetrolinxClient?: boolean;
}

export const CleaningLogsTable = ({ isLoading, headers, data, onRowClick, isManager }: CleaningLogsTableProps) => {
  return (
    <DataTable isLoading={isLoading} headers={headers}>
      <>
        {data?.map(
          ({
            id,
            firstName,
            lastName,
            cleaningDate,
            startTime,
            washroomLabel,
          }: LocationSpecificWashroomLogsForTable) => {
            return (
              <TableRow onClick={() => onRowClick(id)} $clickable key={id}>
                <StyledCell $isManager={isManager}>
                  {isManager ? firstName : firstName[0]} {isManager ? lastName : lastName[0]}
                </StyledCell>
                <StyledCell $isManager={isManager}>{cleaningDate}</StyledCell>
                <StyledCell $isManager={isManager}>{moment(startTime).format("hh:mm A")}</StyledCell>
                {isManager && <StyledCell $isManager={isManager}>{washroomLabel}</StyledCell>}
              </TableRow>
            );
          },
        )}
      </>
    </DataTable>
  );
};

interface StyledCellProps {
  $endTime?: string;
  $isManager?: boolean;
}

const StyledCell = styled(StyledTableCell)<StyledCellProps>`
  height: 50px;
  box-sizing: content-box;
  padding: 10px;
  color: ${({ $endTime, $isManager }: StyledCellProps) =>
    $isManager ? ($endTime === "" ? colors.green.light : "") : ""};
`;
